"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TargetPlatform = void 0;
var TargetPlatform;
exports.TargetPlatform = TargetPlatform;

(function (TargetPlatform) {
  TargetPlatform["APP"] = "app";
  TargetPlatform["WEB"] = "web";
  TargetPlatform["MOBILE"] = "mobile";
})(TargetPlatform || (exports.TargetPlatform = TargetPlatform = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL2VudW1zL1RhcmdldFBsYXRmb3JtLnRzIl0sIm5hbWVzIjpbIlRhcmdldFBsYXRmb3JtIl0sIm1hcHBpbmdzIjoiOzs7Ozs7SUFBWUEsYzs7O1dBQUFBLGM7QUFBQUEsRUFBQUEsYztBQUFBQSxFQUFBQSxjO0FBQUFBLEVBQUFBLGM7R0FBQUEsYyw4QkFBQUEsYyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBlbnVtIFRhcmdldFBsYXRmb3JtIHtcbiAgICBBUFAgPSAnYXBwJyxcbiAgICBXRUIgPSAnd2ViJyxcbiAgICBNT0JJTEUgPSAnbW9iaWxlJyxcbn1cbiJdfQ==